<template>
  <div class="picklistEditor">
    <div class="filterRow">
      <div class="mr-4">
        <v-radio-group v-model="listLevel" row @change="changeLevel">
          <v-radio label="System Level" value="system"></v-radio>
          <v-radio label="Plan Level" value="plan"></v-radio>
        </v-radio-group>
      </div>
      <div class="pickListType">
        <v-select
          label="Picklist type"
          :items="pickListTypes"
          v-model="pickListType"
          outlined
          dense
          hide-details
          @change="changeType"
        >
        </v-select>
      </div>
      <div class="newpicklist">
        <v-btn
          color="primary"
          depressed
          :disabled="!showFormButtons"
          @click.stop="onAddNewPicklist"
          class="ml-2"
        >
          <v-icon class="mr-2">mdi-plus</v-icon>
          Add new picklist
        </v-btn>
      </div>
    </div>
    <v-row v-if="pickListType">
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Picklists</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewItem"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add item
          </v-btn>
        </div>
        <v-card class="pa-2 picklistsList" outlined tile>
          <v-data-table
            :headers="pickListHeaders"
            v-model="selectedPicklist"
            :items="pickLists"
            :loading="loading"
            :items-per-page="-1"
            :single-select="true"
            item-key="Id"
            @click:row="rowClick"
            dense
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <v-alert v-if="!isEditMode && !isSelectedPicklistExists" outlined dense type="info">
          Please select picklist or add the new.
        </v-alert>
        <div v-else class="formContainer">
          <v-form ref="picklistForm" v-model="isFormValid" lazy-validation class="picklistForm">
            <v-text-field
              v-model="editedItem.ShortName"
              label="Name"
              :rules="[rules.required]"
              :readonly="!isEditMode"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="editedItem.Description"
              label="Description"
              :readonly="!isEditMode"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="editedItem.Reference"
              label="Reference"
              :readonly="!isEditMode"
              outlined
              dense
            ></v-text-field>
            <v-checkbox v-model="editedItem.Active" label="Active"></v-checkbox>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isSelectedPicklistExists"
                outlined
                color="error"
                @click="onDelete"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onEdit">Edit</v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onCancel">Cancel</v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="saveChanges"
                class="ml-4"
                :disabled="!isFormValid"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'PicklistEditor',
  components: { Dialog },
  data: () => ({
    loading: false,
    isEditMode: false,
    listLevel: 'system',
    pickListTypes: [],
    pickListType: '',
    pickLists: [],
    editedItem: null,
    selectedPicklist: [],
    pickListHeaders: [
      { text: 'Name', value: 'ShortName' },
      { text: 'Description', value: 'Description' },
      { text: 'Reference', value: 'Reference' },
      { text: 'Active', value: 'Active' },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    isFormValid: false,
  }),
  created() {
    this.getPicklistList();
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    isSelectedPicklistExists() {
      return this.selectedPicklist && this.selectedPicklist.length > 0;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      // console.log(userPermission);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
  methods: {
    onAddNewItem() {
      this.selectedPicklist = [];
      this.isEditMode = true;
      this.editedItem = {
        Id: 0,
        ShortName: null,
        Description: null,
        Reference: null,
        Active: false,
      };
    },
    async onAddNewPicklist() {
      this.selectedPicklist = [];
      this.isEditMode = false;
      this.editedItem = null;
      try {
        var that = this;
        this.$refs.messageBox
          .open('Picklist Type', 'Please enter a new name', { textField: 'Name' })
          .then(async function (name) {
            console.log(name);
            var model = { Level: that.listLevel, Name: name };
            const response = await that.$api.post('/Picklists/InsertPicklistType', model);
            const data = response.data;
            if (data.Value >= 0) {
              console.log(data);
              that.pickListTypes.push(name);
              that.pickListType = name;
              that.getPicklists();
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    rowClick(item, row) {
      row.select(true);
      this.editedItem = Object.assign({}, item);
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      if (this.isSelectedPicklistExists)
        this.editedItem = Object.assign({}, this.selectedPicklist[0]);
    },
    onDelete() {
      this.deletePickList();
    },
    saveChanges() {
      const isFormValid = this.$refs.picklistForm.validate();
      if (isFormValid) {
        this.updatePicklistItem();
      }
    },
    async changeLevel() {
      this.pickListType = '';
      this.pickLists = [];
      this.getPicklistList();
    },
    async getPicklistList() {
      try {
        var data = { params: { level: this.listLevel } };
        let response = await this.$api.get('/Picklists/GetPicklistsList', data);
        this.pickListTypes = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getPicklists(id) {
      try {
        var planId = this.currentPlanId;
        this.loading = true;
        var level = this.listLevel == 'system' ? 0 : 1;
        var data = { params: { planId: planId, level: level, listType: this.pickListType } };
        let response = await this.$api.get('/Picklists/GetPicklistByLevel', data);
        this.pickLists = response.data;
        if (id) {
          const selected = this.pickLists.find((x) => x.Id == id);
          if (selected) {
            this.editedItem = Object.assign({}, selected);
            this.selectedPicklist = [selected];
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async changeType() {
      this.isEditMode = false;
      this.getPicklists();
      this.selectedPicklist = [];
      this.editedItem = null;
    },
    async updatePicklistItem() {
      try {
        var planId = this.listLevel == 'system' ? 0 : this.currentPlanId;
        var model = { planId: planId, listType: this.pickListType, item: this.editedItem };
        const response = await this.$api.post('/Picklists/UpdatePicklistItem', model);
        const data = response.data;

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Picklist was saved successfully',
        });
        this.getPicklists(data.Value);
        this.isEditMode = false;
      } catch (err) {
        this.$store.commit('setNotificationMessage', {
          type: 'error',
          text: 'Something going wrong',
        });
        console.error(err);
      }
    },

    async deletePickList() {
      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this record ?'
        );
        await this.$api.delete('/Picklists/DeletePicklistItem?Id=' + this.selectedPicklist[0].Id);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Picklist was deleted successfully',
        });
        this.selectedPicklist = [];
        this.getPicklists();
      } catch (err) {
        this.$store.commit('setNotificationMessage', {
          type: 'error',
          text: 'Delete unsuccessful',
        });
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.picklistEditor {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}
.picklistEditor .filterRow {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.picklistEditor .filterRow .pickListType {
  width: 300px;
}

.picklistEditor .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.picklistEditor .picklistForm {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 12px;
  padding-top: 5px;
}
.newpicklist {
  padding: 10px 30px;
}
</style>

<style lang="scss" scoped>
.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
